<div class="blog-page">

    <!-- Header -->
    <header class="page-header">
        <div>
            <h1>Blog Management</h1>
        </div>

        <button mat-flat-button color="primary" type="button" (click)="onCreate()">
            <mat-icon>add</mat-icon>
            Create Blog
        </button>
    </header>

    <!-- Table container -->
    <section class="table-card">

        <div class="table-toolbar">
            <div>
                <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
                    <mat-label>Search blogs</mat-label>
                    <mat-icon matPrefix>search</mat-icon>

                    <input matInput [(ngModel)]="searchText" (ngModelChange)="applyFilters()"
                        placeholder="Search title, author or ID" />

                    <button *ngIf="searchText" matSuffix mat-icon-button type="button" aria-label="Clear search"
                        (click)="searchText = ''; applyFilters()">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>

                <mat-form-field appearance="outline" class="status-filter" subscriptSizing="dynamic">
                    <mat-label>Publication status</mat-label>

                    <mat-select [(ngModel)]="selectedStatus" (ngModelChange)="applyFilters()">
                        <mat-option value="all">All statuses</mat-option>
                        <mat-option value="published">Published</mat-option>
                        <mat-option value="draft">Draft</mat-option>
                        <mat-option value="pending">Pending</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <button mat-stroked-button type="button" (click)="loadBlogs()" [disabled]="loading">
                <mat-icon>refresh</mat-icon>
                Refresh
            </button>
        </div>

        <!-- Loading state -->
        <div class="loading-state" *ngIf="loading">
            <mat-spinner diameter="36"></mat-spinner>
            <p>Loading blogs...</p>
        </div>

        <!-- Error state -->
        <div class="error-state" *ngIf="!loading && errorMessage">
            <mat-icon>error_outline</mat-icon>
            <p>{{ errorMessage }}</p>

            <button mat-button color="primary" (click)="loadBlogs()">
                Try again
            </button>
        </div>

        <!-- Blog table -->
        <div class="table-scroll" *ngIf="!loading && !errorMessage">
            <table mat-table [dataSource]="dataSource" matSort class="blog-table">

                <!-- Blog ID -->
                <ng-container matColumnDef="blog_id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        ID
                    </th>

                    <td mat-cell *matCellDef="let blog">
                        <span class="blog-id">#{{ blog.blog_id }}</span>
                    </td>
                </ng-container>

                <!-- Blog details -->
                <ng-container matColumnDef="blog">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Blog Details
                    </th>

                    <td mat-cell *matCellDef="let blog">
                        <div class="blog-details">

                            <img *ngIf="blog.image_path" class="blog-thumbnail" [src]="blog.image_path"
                                [alt]="blog.title" loading="lazy" />

                            <div class="blog-content">
                                <button mat-button color="primary" class="blog-title" type="button"
                                    (click)="onView(blog)" [matTooltip]="blog.title">
                                    {{ blog.title }}
                                </button>

                                <p class="blog-excerpt">
                                    {{ getExcerpt(blog.short_description) }}
                                </p>

                                <span class="updated-date">
                                    Updated:
                                    {{ blog.updated_date | date:'dd MMM yyyy' }}
                                </span>
                            </div>

                        </div>
                    </td>
                </ng-container>

                <!-- Author -->
                <ng-container matColumnDef="author">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Author
                    </th>

                    <td mat-cell *matCellDef="let blog">
                        <div class="author-cell">
                            <div class="author-avatar">
                                {{ blog.author?.charAt(0) || 'U' }}
                            </div>

                            <span>{{ blog.author || 'Unknown' }}</span>
                        </div>
                    </td>
                </ng-container>

                <!-- Publication status -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Status
                    </th>

                    <td mat-cell *matCellDef="let blog">
                        <span class="status-badge" [class.published]="isPublished(blog.status)"
                            [class.draft]="blog.status?.toLowerCase() === 'draft'"
                            [class.pending]="blog.status?.toLowerCase() === 'pending'" [class.other-status]="
                !['published', 'draft', 'pending']
                  .includes(blog.status?.toLowerCase())
              ">
                            <span class="status-dot"></span>
                            {{ blog.status || 'Unknown' }}
                        </span>
                    </td>
                </ng-container>

                <!-- Active status -->
                <ng-container matColumnDef="is_active">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Visibility
                    </th>

                    <td mat-cell *matCellDef="let blog">
                        <span class="visibility-badge" [class.is-active]="isActive(blog.is_active)"
                            [class.is-inactive]="!isActive(blog.is_active)">
                            {{ isActive(blog.is_active) ? 'Active' : 'Inactive' }}
                        </span>
                    </td>
                </ng-container>

                <!-- Creation date -->
                <ng-container matColumnDef="created_date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Created Date
                    </th>

                    <td mat-cell *matCellDef="let blog">
                        <div class="date-cell">
                            <span>
                                {{ blog.created_date | date:'dd MMM yyyy' }}
                            </span>

                            <small>
                                {{ blog.created_date | date:'hh:mm a' }}
                            </small>
                        </div>
                    </td>
                </ng-container>

                <!-- Actions -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="actions-header">
                        Actions
                    </th>

                    <td mat-cell *matCellDef="let blog">
                        <div class="action-buttons">

                            <button mat-icon-button type="button" matTooltip="View blog" aria-label="View blog"
                                (click)="onView(blog)">
                                <mat-icon>visibility</mat-icon>
                            </button>

                            <button mat-icon-button color="primary" type="button" matTooltip="Edit blog"
                                aria-label="Edit blog" (click)="onEdit(blog)">
                                <mat-icon>edit</mat-icon>
                            </button>

                            <button mat-icon-button color="warn" type="button" matTooltip="Delete blog"
                                aria-label="Delete blog" (click)="onDelete(blog)">
                                <mat-icon>delete_outline</mat-icon>
                            </button>

                        </div>
                    </td>
                </ng-container>

                <!-- Header and body rows -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

                <!-- Empty state -->
                <tr class="mat-mdc-row" *matNoDataRow>
                    <td class="mat-mdc-cell empty-cell" [attr.colspan]="displayedColumns.length">
                        <mat-icon>search_off</mat-icon>

                        <strong>No blogs found</strong>

                        <span>
                            Try changing your search or publication status filter.
                        </span>
                    </td>
                </tr>

            </table>
        </div>

        <!-- Pagination -->
        <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons
            aria-label="Select blog page"></mat-paginator>

    </section>
</div>